import React, {useState, useEffect} from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import apiClient from "../../../../utils/apiClient";
import {toast} from "react-toastify";
import {isEmpty} from "lodash"
import TableReport from "../../../common/table/table";
import Table from "./shopTimeApproversTable";
import ModalConfirmation from "../../../common/modal/ModalConfirmation";
import {removeObjFromArray} from "../../../../utils/arrayHelpers";
import ShopTimeApproversCreateModal from "./shopTimeApproversCreateModal";

const ShopTimeApprovers = () => {
    const [tableData, setTableData] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});
    const [formModal, setFormModal] = useState({isOpen: false, action: 'create'});
    const [deleteModal, setDeleteModal] = useState({isOpen: false, message: <p></p>});

    // delete function
    const deleteApprover = () => {
        // console.log(selectedRow.id)
        apiClient
            .delete('shopTimeApprovers/' + selectedRow.id)
            .then(response => {
                const newTableData = removeObjFromArray(tableData, "id", response.data.id)
                setTableData(newTableData);
                toast.success(response.data.message);
            })
            .catch(function () {
                //In case of error do nothing!!
                //let apiClient to handle the error
            })
            .then(function () {
                //close deactivateModal
                setDeleteModal({...deleteModal, isOpen: false})
            });
    }

    useEffect(() => {
        apiClient
            .get('shopTimeApprovers')
            .then(response => {
                if (isEmpty(response.data)) {
                    setTableData([]);
                    return;
                }

                setTableData(response.data.records);
            });
    }, [setTableData]);

    return (
        <>
            <Breadcrumb title="Shop Time Approvers" parent="Admin"/>
            <div className="container-fluid">
                <TableReport
                    columns={Table(setSelectedRow, setFormModal, setDeleteModal)}
                    data={tableData}
                    getExportFileName={() => 'shop_time_approvers'}
                    exportOptions={{pdf: false, xlsx: true, csv: true}}
                    withGlobalSearch={true}
                    scrollable={true}
                />
                <ShopTimeApproversCreateModal
                    title="Add Shop Time Approver"
                    modal={formModal}
                    setModal={setFormModal}
                    tableData={tableData}
                    setTableData={setTableData}
                />
                <ModalConfirmation
                    modal={deleteModal}
                    setModal={setDeleteModal}
                    title="Delete Shop Time Approver"
                    onConfirm={deleteApprover}
                />
            </div>
        </>
    );
}

export default ShopTimeApprovers;
